import { TitleEntityAssetResponse } from 'components/map/types';
import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';

// Create a custom hook for the title entity asset atom
const useTitleEntityAssetAtom = (href?: string) =>
  useMemo(() => createResourceAtom<TitleEntityAssetResponse>(href), [href]);

export { useTitleEntityAssetAtom };
